import { render, staticRenderFns } from "./OrderAttachedFilesDrawer.vue?vue&type=template&id=119f6e36&scoped=true"
import script from "./OrderAttachedFilesDrawer.vue?vue&type=script&lang=js"
export * from "./OrderAttachedFilesDrawer.vue?vue&type=script&lang=js"
import style0 from "./OrderAttachedFilesDrawer.vue?vue&type=style&index=0&id=119f6e36&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119f6e36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('119f6e36')) {
      api.createRecord('119f6e36', component.options)
    } else {
      api.reload('119f6e36', component.options)
    }
    module.hot.accept("./OrderAttachedFilesDrawer.vue?vue&type=template&id=119f6e36&scoped=true", function () {
      api.rerender('119f6e36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/order/AdminSummarySubs/AttachedFiles/OrderAttachedFilesDrawer.vue"
export default component.exports